import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';

/** 
 * @typedef {import('@/types/api').components['schemas']['UserOut']} UserOut 
 */

export const ProtectedRoute = ({ children, requiredRole }) => {
  /** @type {{ user: UserOut | null, loading: boolean }} */
  const { user, loading, activeRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="loading-spinner">در حال بررسی وضعیت...</div>;
  }

  // 1. If not logged in, redirect to login page
  // Passes 'from' location to redirect back after successful login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 2. Role-based access control
  const isSuperAdmin =
    activeRole === 'super_admin';

  if (requiredRole === 'super_admin' && !isSuperAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requiredRole && requiredRole !== 'super_admin' && activeRole !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  // 3. User is authorized
  return children;
};